import React from 'react';
import { Icon } from '@ontruck/orc';
import Tippy from '@tippyjs/react';

const t = {
  no_instructions: 'No instructions specified for this user',
};

const SpecialInstructions = ({ instructions }) => {
  return (
    <Tippy
      theme="light"
      placement="bottom"
      interactive
      maxWidth="none"
      content={instructions || t.no_instructions}
    >
      <span>{instructions && <Icon glyph="comments" size="1.6rem" color="primary300" />}</span>
    </Tippy>
  );
};

export default SpecialInstructions;
